// extracted by mini-css-extract-plugin
export default {"menu":"MenuItem_menu__ElOvA","scrolableContainer":"MenuItem_scrolableContainer__TQfeO"};